<template>
  <div style="padding: 20px">
    <v-card>
      <v-toolbar class="indigo white--text" dense primary-title>
        <v-toolbar-title>Gestione Eventi</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="addEvent">
              <v-icon color="primary"> mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Nuovo Evento</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="saveEvents"
              class="ml-10"
            >
              <v-icon color="success"> mdi-floppy</v-icon>
            </v-btn>
          </template>
          <span>Salva</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" small elevation="1" @click="showFilter">
              <v-icon color="purple"> mdi-filter</v-icon>
            </v-btn>
          </template>
          <span>Filtri</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              small
              elevation="1"
              @click="$router.replace('/home')"
            >
              <v-icon class="error--text"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Indietro</span>
        </v-tooltip>
      </v-toolbar>

      <v-progress-linear
        indeterminate
        color="cyan"
        v-if="loading"
        id="progress"
      >
      </v-progress-linear>

      <v-row v-if="filterVisible">
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-select
            label="modulo"
            :items="moduli"
            v-model="filtro_modulo"
            dense
            outlined
            class="ma-2"
            item-text="des_modulo"
            item-value="id_modulo"
            prepend-icon="mdi-close"
            @click:prepend="filtro_modulo = -1"
          ></v-select>
        </v-col>
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-menu
            ref="menu-da"
            v-model="menu_filtro_di"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                label="Data Inizio Da"
                autocomplete="off"
                persistent-hint
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                v-model="filtro_di"
                outlined
                class="ma-2"
              >
              </v-text-field>
            </template>
            <v-date-picker no-title locale="it" v-model="filtro_di">
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-menu
            ref="menu-da"
            v-model="menu_filtro_ai"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                label="Data Inizio A"
                autocomplete="off"
                persistent-hint
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                v-model="filtro_ai"
                outlined
                class="ma-2"
              >
              </v-text-field>
            </template>
            <v-date-picker no-title locale="it" v-model="filtro_ai">
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-menu
            ref="menu-da"
            v-model="menu_filtro_df"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                label="Data Fine Da"
                autocomplete="off"
                persistent-hint
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                v-model="filtro_df"
                outlined
                class="ma-2"
              >
              </v-text-field>
            </template>
            <v-date-picker no-title locale="it" v-model="filtro_df">
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="flex-grow-1 flex-shrink-0">
          <v-menu
            ref="menu-da"
            v-model="menu_filtro_af"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                label="Data Fine A"
                autocomplete="off"
                persistent-hint
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
                v-model="filtro_af"
                outlined
                class="ma-2"
              >
              </v-text-field>
            </template>
            <v-date-picker no-title locale="it" v-model="filtro_af">
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="
          filterVisible
            ? events.filter(
                (e) =>
                  (e.modulo == filtro_modulo || filtro_modulo == -1) &&
                  (Date.parse(e.data_inizio) > Date.parse(filtro_di) ||
                    filtro_di == '') &&
                  (Date.parse(e.data_inizio) < Date.parse(filtro_ai) ||
                    filtro_ai == '') &&
                  (Date.parse(e.data_fine) > Date.parse(filtro_df) ||
                    filtro_df == '') &&
                  (Date.parse(e.data_fine) < Date.parse(filtro_af) ||
                    filtro_af == '') &&
                  e.validita == 1
              )
            : events.filter((e) => e.validita == 1)
        "
      >
        <template v-slot:[`item.modifica`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small elevation="1" @click="edit(item)">
                <v-icon color="primary"> mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Modifica</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.elimina`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small elevation="1" @click="elimina(item)">
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-dialog v-model="editDialog" width="1000">
        <v-card>
          <v-toolbar class="indigo white--text" dense>
            <v-toolbar-title class="white--text">
              {{ dialogTitle }}
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="saveEvent" small>
                  <v-icon color="success"> mdi-floppy </v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="closeEdit" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </template>
              <span>Chiudi</span>
            </v-tooltip>
          </v-toolbar>

          <v-progress-linear
            indeterminate
            color="cyan"
            v-if="loading"
            id="progress"
          >
          </v-progress-linear>

          <v-col cols="12">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  dense
                  outlined
                  label="Descrizione"
                  v-model="tempItem.descrizione"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3">
                <v-menu
                  ref="menu-da"
                  v-model="menu_d_da"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      label="Data Da"
                      autocomplete="off"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      v-model="tempItem.data_inizio"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    locale="it"
                    v-model="tempItem.data_inizio"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3">
                <v-menu
                  ref="menu-da"
                  v-model="menu_t_da"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      label="Ora Da"
                      autocomplete="off"
                      persistent-hint
                      prepend-icon="mdi-clock"
                      v-bind="attrs"
                      v-on="on"
                      v-model="tempItem.ora_inizio"
                    >
                    </v-text-field>
                  </template>
                  <v-time-picker
                    no-title
                    format="24hr"
                    v-model="tempItem.ora_inizio"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="3">
                <v-menu
                  ref="menu-da"
                  v-model="menu_d_a"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      label="Data A"
                      autocomplete="off"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      v-model="tempItem.data_fine"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    locale="it"
                    v-model="tempItem.data_fine"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3">
                <v-menu
                  ref="menu-da"
                  v-model="menu_t_a"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      label="Ora A"
                      autocomplete="off"
                      persistent-hint
                      prepend-icon="mdi-clock"
                      v-bind="attrs"
                      v-on="on"
                      v-model="tempItem.ora_fine"
                    >
                    </v-text-field>
                  </template>
                  <v-time-picker
                    no-title
                    format="24hr"
                    v-model="tempItem.ora_fine"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3">
                <v-checkbox
                  label="Ripete ogni giorno"
                  v-model="tempItem.ripetizione"
                  @click="repKey++"
                >
                </v-checkbox>
              </v-col>
              <v-col cols="3" key="repKey">
                <v-menu
                  :disabled="!tempItem.ripetizione"
                  ref="menu-da"
                  v-model="menu_t_rep"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :disabled="!tempItem.ripetizione"
                      dense
                      label="Ora Ripetizione"
                      autocomplete="off"
                      persistent-hint
                      prepend-icon="mdi-clock"
                      v-bind="attrs"
                      v-on="on"
                      v-model="tempItem.ora_ripetizione"
                    >
                    </v-text-field>
                  </template>
                  <v-time-picker
                    no-title
                    format="24hr"
                    v-model="tempItem.ora_ripetizione"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="3">
                <v-menu
                  ref="menu-da"
                  v-model="menu_d_s"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      label="Data Scadenza"
                      autocomplete="off"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      v-model="tempItem.data_scadenza"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    locale="it"
                    v-model="tempItem.data_scadenza"
                  >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3">
                <v-menu
                  ref="menu-da"
                  v-model="menu_t_s"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      label="Ora Scadenza"
                      autocomplete="off"
                      persistent-hint
                      prepend-icon="mdi-clock"
                      v-bind="attrs"
                      v-on="on"
                      v-model="tempItem.ora_scadenza"
                    >
                    </v-text-field>
                  </template>
                  <v-time-picker
                    no-title
                    format="24hr"
                    v-model="tempItem.ora_scadenza"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <TextEditor
                  v-model="queryObj"
                  :key="queryEditKey"
                  :template="queryTemplate"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6">
                <v-select
                  outlined
                  dense
                  label="Email"
                  :items="emails"
                  item-text="des_modello"
                  item-value="id_email_modello"
                  v-model="tempItem.email"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  outlined
                  dense
                  label="Modulo"
                  :items="moduli"
                  item-text="des_modulo"
                  item-value="id_modulo"
                  v-model="tempItem.modulo"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-card>
      </v-dialog>
    </v-card>

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import TextEditor from "@/components/GRAPH/Dashboard/Editor/TextEditor.vue";
export default {
  name: "Event",
  components: {
    SnackbarQV,
    TextEditor,
  },
  data() {
    return {
      queryEditKey: 0,
      filtro_di: "",
      filtro_ai: "",
      filtro_df: "",
      filtro_af: "",
      menu_filtro_di: false,
      menu_filtro_ai: false,
      menu_filtro_df: false,
      menu_filtro_af: false,
      filtro_modulo: -1,
      nextTempId: 1,
      loading: false,
      dialogTitle: "",
      menu_d_da: false,
      menu_d_a: false,
      menu_t_da: false,
      menu_t_a: false,
      menu_t_rep: false,
      menu_t_s: false,
      menu_d_s: false,
      editDialog: false,
      filterVisible: false,
      repKey: 0,
      tempItem: {},
      editingItem: {},
      queryObj: {
        query: "",
      },
      queryTemplate: [],
      moduli: [],
      emails: [],
      events: [],
      filtered: [],
      headers: [
        {
          text: "Modifica",
          value: "modifica",
        },
        {
          text: "Descrizione",
          value: "descrizione",
        },
        {
          text: "Data Inizio",
          value: "data_inizio",
        },
        {
          text: "Ora Inizio",
          value: "ora_inizio",
        },
        {
          text: "Data Fine",
          value: "data_fine",
        },
        {
          text: "Ora Fine",
          value: "ora_fine",
        },
        {
          text: "Modulo",
          value: "des_modulo",
        },
        {
          text: "Elimina",
          value: "elimina",
        },
      ],
    };
  },
  mounted() {
    this.inizializza();
  },
  methods: {
    async inizializza() {
      this.loading = true;
      //carica indirizzi email
      var request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getemailmodello",
          token: localStorage.user_token,
        },
      };
      await this.$store.dispatch("api", request).then((res) => {
        this.emails = Array.from(res.data);
      });
      //carica lista moduli
      request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getmoduli",
          token: localStorage.user_token,
        },
      };
      await this.$store.dispatch("api", request).then((res) => {
        this.moduli = Array.from(res.data.result.moduli);
      });
      //carica eventi
      request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getevents",
          token: localStorage.user_token,
        },
      };
      await this.$store.dispatch("api", request).then((res) => {
        this.events = Array.from(res.data.result.eventi);
        this.events.forEach((e) => {
          e.tempId = -1;
          if (e.data_inizio.length > 10) {
            e.data_inizio = e.data_inizio.slice(0, 10);
          }
          if (e.data_fine.length > 10) {
            e.data_fine = e.data_fine.slice(0, 10);
          }
          if (e.data_scadenza.length > 10) {
            e.data_scadenza = e.data_scadenza.slice(0, 10);
          }
          if (e.ora_inizio.length > 5) {
            e.ora_inizio = e.ora_inizio.slice(0, 5);
          }
          if (e.ora_fine.length > 5) {
            e.ora_fine = e.ora_fine.slice(0, 5);
          }
          if (e.ora_ripetizione.length > 5) {
            e.ora_ripetizione = e.ora_ripetizione.slice(0, 5);
          }
          if (e.ora_scadenza.length > 5) {
            e.ora_scadenza = e.ora_scadenza.slice(0, 5);
          }
          this.getmodulo(e);
        });
      });
      this.loading = false;
    },
    edit(item) {
      this.dialogTitle = "Modifica Evento";
      this.tempItem = Object.assign({}, item);
      this.queryObj.query = this.tempItem.query;
      this.queryEditKey += 1;
      this.editingItem = item;
      this.editDialog = true;
    },
    elimina(item) {
      console.log(item);
      console.log(this.events);
      var index = -1;
      if (item.id_evento == -1) {
        for (let i = 0; i < this.events.length; i++) {
          if (
            this.events[i].id_evento == -1 &&
            this.events[i].tempId == item.tempId
          ) {
            index = i;
            break;
          }
        }
      } else {
        for (let i = 0; i < this.events.length; i++) {
          if (this.events[i].id_evento == item.id_evento) {
            this.events[i].validita = 0;
            break;
          }
        }
      }
      if (index != -1) {
        this.events.splice(index, 1);
      }
    },
    closeEdit() {
      console.log("test");
      this.editDialog = false;
    },
    showFilter() {
      console.log(this.filtro_di);
      console.log(this.filtro_ai);
      console.log(this.filtro_df);
      console.log(this.filtro_af);
      this.filterVisible = !this.filterVisible;
    },
    getmodulo(event) {
      if (event.modulo == -1) {
        event.des_modulo = "Nessuno";
      }
      this.moduli.forEach((e) => {
        if (e.id_modulo == event.modulo) {
          event.des_modulo = e.des_modulo;
          return;
        }
      });
    },
    saveEvent() {
      this.editingItem.descrizione = this.tempItem.descrizione;
      this.editingItem.data_inizio = this.tempItem.data_inizio;
      this.editingItem.data_fine = this.tempItem.data_fine;
      this.editingItem.data_scadenza = this.tempItem.data_scadenza;
      this.editingItem.ora_scadenza = this.tempItem.ora_scadenza;
      this.editingItem.ora_inizio = this.tempItem.ora_inizio;
      this.editingItem.ora_fine = this.tempItem.ora_fine;
      this.editingItem.ripetizione = this.tempItem.ripetizione;
      this.editingItem.ora_ripetizione = this.tempItem.ora_ripetizione;
      this.editingItem.query = this.queryObj.query;
      this.editingItem.email = this.tempItem.email;
      this.editingItem.modulo = this.tempItem.modulo;
      this.getmodulo(this.editingItem);
      this.editDialog = false;
      this.$refs.SnackbarQV.print("success", "Evento Salvato");
    },
    addEvent() {
      var dateNow = new Date();
      this.events.push({
        id_evento: -1,
        descrizione: "Nuovo Evento",
        data_scadenza:
          dateNow.getFullYear().toString() +
          "-" +
          dateNow.getMonth().toString().padStart(2, "0") +
          "-" +
          dateNow.getDate().toString().padStart(2, "0"),
        data_inizio:
          dateNow.getFullYear().toString() +
          "-" +
          dateNow.getMonth().toString().padStart(2, "0") +
          "-" +
          dateNow.getDate().toString().padStart(2, "0"),
        data_fine:
          dateNow.getFullYear().toString() +
          "-" +
          dateNow.getMonth().toString().padStart(2, "0") +
          "-" +
          dateNow.getDate().toString().padStart(2, "0"),
        ora_inizio:
          dateNow.getHours().toString().padStart(2, "0") +
          ":" +
          dateNow.getMinutes().toString().padStart(2, "0"),
        ora_fine:
          dateNow.getHours().toString().padStart(2, "0") +
          ":" +
          dateNow.getMinutes().toString().padStart(2, "0"),
        ripetizione: 0,
        ora_ripetizione:
          dateNow.getHours().toString().padStart(2, "0") +
          ":" +
          dateNow.getMinutes().toString().padStart(2, "0"),
        ora_scadenza:
          dateNow.getHours().toString().padStart(2, "0") +
          ":" +
          dateNow.getMinutes().toString().padStart(2, "0"),
        query: "",
        email: -1,
        tempId: this.nextTempId,
        validita: 1,
        modulo: -1,
        des_modulo: "Nessuno",
      });
      this.nextTempId += 1;
    },
    saveEvents() {
      this.loading = true;
      var request = {
        controller: "Global",
        method: "PUT",
        richiesta: {
          action: "setevents",
          eventi: this.events,
          token: localStorage.user_token,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        if (res.data.statusCode == 200) {
          this.events = Array.from(res.data.result.eventi);
          this.events.forEach((e) => {
            e.tempId = -1;
            if (e.data_inizio.length > 10) {
              e.data_inizio = e.data_inizio.slice(0, 10);
            }
            if (e.data_fine.length > 10) {
              e.data_fine = e.data_fine.slice(0, 10);
            }
            if (e.data_scadenza.length > 10) {
              e.data_scadenza = e.data_scadenza.slice(0, 10);
            }
            if (e.ora_inizio.length > 5) {
              e.ora_inizio = e.ora_inizio.slice(0, 5);
            }
            if (e.ora_fine.length > 5) {
              e.ora_fine = e.ora_fine.slice(0, 5);
            }
            if (e.ora_ripetizione.length > 5) {
              e.ora_ripetizione = e.ora_ripetizione.slice(0, 5);
            }
            if (e.ora_scadenza.length > 5) {
              e.ora_scadenza = e.ora_scadenza.slice(0, 5);
            }
            this.getmodulo(e);
          });
          this.$refs.SnackbarQV.print("success", "Eventi Salvati");
        } else {
          this.$refs.SnackbarQV.print("error", "Eventi Non Salvati");
        }
        this.loading = false;
      });
    },
  },
};
</script>